import React, { useState } from 'react';
import styles from './index.modules.less';
import MarqueeText from '../../../../../../components/MarqueeText';
import { Icon } from 'antd-mobile';
export default function BuyAgainBar({ text, onClick, actionBtn, onClose }) {
  const [visible, setVisible] = useState(true);
  const handleClose = () => {
    setVisible(false);
    onClose && onClose();
  };
  return visible ? (
    <div className={styles.container}>
      <div className={styles.content} onClick={onClick}>
        <MarqueeText text={text}></MarqueeText>
      </div>
      {actionBtn && actionBtn.visible && (
        <div className={styles.actionBtn} style={actionBtn.style || {}} onClick={actionBtn.onClick}>
          {actionBtn.text}
        </div>
      )}
      <Icon type="cross" size="sm" onClick={handleClose} style={{ flexShrink: 0 }} />
    </div>
  ) : null;
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/components/BuyAgainBar/index.js